export default "__VITE_ASSET__CGpTGw0N__"